window.SystemJS = window.System;

function insertNewImportMap(newMapJSON) {
  const newScript = document.createElement('script');
  newScript.type = 'systemjs-importmap';
  newScript.text = JSON.stringify(newMapJSON);
  const allMaps = document.querySelectorAll('script[type="systemjs-importmap"]');

  allMaps[allMaps.length - 1].insertAdjacentElement('afterEnd', newScript);
}

const devDependencies = {
  imports: {
    react: 'https://unpkg.com/umd-react@19.2.1/dist/react.development.js',
    'react-dom': 'https://unpkg.com/umd-react@19.2.1/dist/react-dom.development.js',
    'react-dom/server': 'https://unpkg.com/umd-react@19.2.1/dist/react-dom-server.development.js',
    // React Router v7+ no longer provides UMD builds
    // Using peerDependencies pattern - auth-ui will resolve from catalog-ui's node_modules
    //'@material-ui/core': 'https://unpkg.com/@material-ui/core@4.6.0/umd/material-ui.development.js',
    lodash: 'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.js',
  },
};

const prodDependencies = {
  imports: {
    react: 'https://unpkg.com/umd-react@19.2.1/dist/react.production.min.js',
    'react-dom': 'https://unpkg.com/umd-react@19.2.1/dist/react-dom.production.min.js',
    'react-dom/server': 'https://unpkg.com/umd-react@19.2.1/dist/react-dom-server.production.min.js',
    // React Router v7+ no longer provides UMD builds
    // Using peerDependencies pattern - auth-ui will resolve from catalog-ui's node_modules
    //'@material-ui/core': 'https://unpkg.com/@material-ui/core@4.6.0/umd/material-ui.production.min.js',
    lodash: 'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js',
  },
};

const prodMode = PRODUCTION;
if (prodMode) {
  insertNewImportMap(prodDependencies);
} else {
  insertNewImportMap(devDependencies);
}
